export default __webpack_public_path__ + "static/media/f_paragraph.0037e0d0.svg";